// Use the google analytics tracker or the console.log if not available
// tslint:disable-next-line:no-console
export default window.ga || console.log.bind(console);
